module.exports = __webpack_public_path__ + "img/binxi3.b5135b22.png";